export default "__VITE_ASSET__Cp2G$yF6__"